export default __webpack_public_path__ + "static/media/student.05bafd13.svg";